"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDeactivationParams = buildDeactivationParams;
const core_1 = require("@inversifyjs/core");
function buildDeactivationParams(serviceReferenceManager) {
    return {
        getBindings: serviceReferenceManager.bindingService.get.bind(serviceReferenceManager.bindingService),
        getBindingsFromModule: serviceReferenceManager.bindingService.getByModuleId.bind(serviceReferenceManager.bindingService),
        getClassMetadata: core_1.getClassMetadata,
        getDeactivations: serviceReferenceManager.deactivationService.get.bind(serviceReferenceManager.deactivationService),
    };
}
//# sourceMappingURL=buildDeactivationParams.js.map